import { lazy } from 'react';
import { definePlugin } from 'sanity';
import { route } from 'sanity/router';
import { EyeOpenIcon } from '@sanity/icons';
const visionTool = definePlugin(options => {
  const {
    name,
    title,
    icon,
    ...config
  } = options || {};
  return {
    name: "@sanity/vision",
    tools: [{
      name: name || "vision",
      title: title || "Vision",
      icon: icon || EyeOpenIcon,
      component: lazy(() => import('./_chunks/SanityVision-2ce57d41.js')),
      options: config,
      router: route.create("/*")
    }]
  };
});
export { visionTool };
//# sourceMappingURL=index.esm.js.map
